'use strict';

import angular from 'angular';
import raven from 'raven';
import AddItemTpl from './add-item.html';
import AddItemController from './add-item.controller';

class ProcedureController {
    /* @ngInject */
    constructor(
        ItemsService,
        $mdDialog
    ) {
        Object.assign(this, {ItemsService, $mdDialog});
    }

    $onInit() {
        this.updateTotals();
        this.canBeDeleted = !this.items.some(i => i.osItems && i.osItems.length > 0);
    }

    updateTotals() {
        let totals = {
            cost: 0,
            price: 0,
            finalCost: 0,
            finalPrice: 0
        };
        this.items.forEach(item => {
            if (item.markedForDeletion)
                return;
            totals.cost += item.cost;
            totals.price += item.price;
            totals.finalCost += item.finalCost;
            totals.finalPrice += item.finalPrice;
        });
        Object.assign(this, totals);
    }

    save() {
        
    }

    delete(ev) {
        var confirm = this.$mdDialog.confirm()
            .title('Confirmacion')
            .textContent('Desea realmente eliminar el tramite?')
            .ariaLabel('Lucky day')
            .targetEvent(ev)
            .ok('Si, eliminar')
            .cancel('Cancelar');

        this.$mdDialog.show(confirm).then(() => {
            this.markedForDeletion = true;
            this.onDelete({
                $event: {
                    model: this.model
                }
            });
        });
    }

    itemSave($event) {
        this.updateTotals();
        this.onItemSave({
            $event: {
                procedure: this.model,
                item: $event.model,
                promise: $event.promise
            }
        });
    }

    itemDelete($event) {
        this.updateTotals();
    }

    itemUpdateAssociatedAmount($event) {
        let item = $event.model,
            associatedAmount = $event.associatedAmount;
        this.updateTotals();
        this.onUpdateAssociatedAmount({
            $event: {
                item: $event.model,
                associatedAmount: associatedAmount
            }
        });
    }

    addItem(ev) {
        let itemTemplates = this.itemTemplates.concat([
            {
                id: -1,
                name: 'Libre (ingresar descripcion en el siguiente paso)'
            }
        ]);
        this.$mdDialog.show({
            controller: AddItemController,
            template: AddItemTpl,
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: true,
            locals: {
                itemTemplates: itemTemplates
            }
        }).then(data => {
            let itemTpl = data.itemTpl;
            if (itemTpl.id == -1) {
                var prompt = this.$mdDialog.prompt()
                    .title('Item libre')
                    .placeholder('Nombre o descripcion')
                    .required(true)
                    .targetEvent(ev)
                    .ok('Agregar')
                    .cancel('Cancelar');
                return this.$mdDialog.show(prompt).then(result => {
                    return {
                        name: result,
                        cost: 0,
                        price: 0
                    };
                });
            } else {
                return itemTpl;
            }
        }).then(itemTpl => {
            let item = this.ItemsService.createFromTpl({
                template: itemTpl,
                procedure: this.model
            });
            this.showAddSpinner = true;
            return this.ItemsService.save(item);
        }).then(item => {
            this.showAddSpinner = false;
            this.items.push(item);
        }, err => {
            // err might be undefined if name dialog was cancelled
            if (err)
                raven.captureException(new Error(err));
        });
    }
}

export default ProcedureController;
